

























import Vue from 'vue'
import { IChronologyAction } from '@/types/data-objects/item-histories'

export default Vue.extend({
  name: 'ChronologyAction',

  props: {
    actionInfo: {
      type: Object as () => IChronologyAction,
      required: true,
    },
    visibilityNote: {
      type: String,
      default: '',
      required: false,
    },
  },
  computed: {
    avatarSize(): number {
      if (this.$screen.isDesktop(this.$mq)) {
        return 40
      }
      if (this.$screen.isTabletOrMobile(this.$mq)) {
        return 24
      }
    },
  },
})
